export const API_CONFIG = {
    BASE_URL: import.meta.env.VITE_API_BASE_URL,
    VERSION: import.meta.env.VITE_API_VERSION,
    API_USER: import.meta.env.VITE_API_USER,
    API_KEY: import.meta.env.VITE_API_KEY,
    TIMEOUT: 10000,
} as const;

export const ROUTES = {
    USER_SHOW: 'user/show',
    PENALTY_INDEX: 'penalty/index',
    PARKING_INDEX: 'orders/index',
    CAR_INDEX: 'user_cars/index',
    CREDIT_CARD_INDEX: 'credit_cards/index',
} as const;

export const STATUS_COLORS = {
    // User statuses
    active: 'bg-green-100 text-green-800',
    inactive: 'bg-gray-100 text-gray-800',
    suspended: 'bg-red-100 text-red-800',

    // Penalty statuses
    paid: 'bg-green-100 text-green-800',
    unpaid: 'bg-red-100 text-red-800',
    yes: 'bg-red-100 text-red-800',
    no: 'bg-green-100 text-green-800',
    pending: 'bg-yellow-100 text-yellow-800',
    blocked: 'bg-orange-100 text-orange-800',
    isCancelled: 'bg-gray-100 text-gray-800',
    confirmed: 'bg-green-100 text-green-800',
    not_confirmed: 'bg-yellow-100 text-yellow-800',

    // Parking statuses
    completed: 'bg-green-100 text-green-800',
    cancelled: 'bg-red-100 text-red-800',

    // Order states
    processed: 'bg-green-100 text-green-800',
    declined: 'bg-red-100 text-red-800',
    awaiting_authorization: 'bg-yellow-100 text-yellow-800',
    refunded: 'bg-gray-500 text-white',

    // Default
    default: 'bg-blue-100 text-blue-800',
} as const;

export const CURRENCY_CONFIG = {
    locale: 'uk-UA',
    currency: 'UAH',
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
} as const;

export const DATE_FORMAT_OPTIONS = {
    dateTime: {
        year: 'numeric' as const,
        month: 'short' as const,
        day: 'numeric' as const,
        hour: '2-digit' as const,
        minute: '2-digit' as const,
    },
    date: {
        year: 'numeric' as const,
        month: 'short' as const,
        day: 'numeric' as const,
    },
    time: {
        hour: '2-digit' as const,
        minute: '2-digit' as const,
    },
} as const;

export const LOCAL_STORAGE_KEYS = {
    AUTH_TOKEN: 'user_viewer_auth_token',
    LAST_SECTION: 'user_viewer_last_section',
    SIDEBAR_STATE: 'user_viewer_sidebar_state',
} as const;

export const BREAKPOINTS = {
    SM: 640,
    MD: 768,
    LG: 1024,
    XL: 1280,
} as const;
